// extracted by mini-css-extract-plugin
export var button = "_dq-0";
export var icon = "_dq-1";